import React from 'react';
import { UserPlusIcon, UsersIcon, AlertTriangleIcon, ClockIcon, CheckCircleIcon, FileTextIcon, CreditCardIcon } from 'lucide-react';
export function VendorDashboard({
  vendors,
  setCurrentView,
  locale = 'en-US'
}) {
  // Calculate summary statistics
  const totalVendors = vendors.length;
  const activeVendors = vendors.filter(vendor => vendor.vendorStatus?.name === 'Active').length;
  const pendingOnboarding = vendors.filter(vendor => vendor.vendorStatus?.name === 'Pending Onboarding' || vendor.vendorStatus?.name === 'Invited').length;
  // Check for compliance issues
  const complianceIssues = vendors.filter(vendor => !vendor.isCompliant).length;
  // Get recent vendors (sorted by creation date)
  const recentVendors = [...vendors].sort((a, b) => new Date(b.createdUtc).getTime() - new Date(a.createdUtc).getTime()).slice(0, 5);
  // Get vendors with compliance issues
  const vendorsWithIssues = vendors.filter(vendor => !vendor.isCompliant || vendor.complianceIssues.length > 0).slice(0, 5);
  // Navigate to vendor list with status filter
  const handleViewVendorsByStatus = status => {
    // Store the filter preference (in a real app, this would be passed as a prop or through state management)
    sessionStorage.setItem('vendorStatusFilter', status);
    setCurrentView('vendors');
  };
  return <div data-id="element-21709">
      <div className="mb-8 flex justify-between items-center" data-id="element-21710">
        <div data-id="element-21711">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-21712">
            Vendor Dashboard
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-21713">
            Overview of your vendor network and compliance status
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-21714">
          <button onClick={() => setCurrentView('onboard-vendor')} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-21715">
            <UserPlusIcon className="h-4 w-4 mr-1" data-id="element-21716" />
            Add New Vendor
          </button>
          <button onClick={() => setCurrentView('vendors')} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-21717">
            <UsersIcon className="h-4 w-4 mr-1" data-id="element-21718" />
            View All Vendors
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-8" data-id="element-21719">
        <button onClick={() => setCurrentView('vendors')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-21720">
          <div className="p-5" data-id="element-21721">
            <div className="flex items-center" data-id="element-21722">
              <div className="flex-shrink-0" data-id="element-21723">
                <UsersIcon className="h-6 w-6 text-gray-400" data-id="element-21724" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-21725">
                <dl data-id="element-21726">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-21727">
                    Total Vendors
                  </dt>
                  <dd data-id="element-21728">
                    <div className="text-lg font-medium text-gray-900" data-id="element-21729">
                      {totalVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => handleViewVendorsByStatus('Active')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-21730">
          <div className="p-5" data-id="element-21731">
            <div className="flex items-center" data-id="element-21732">
              <div className="flex-shrink-0" data-id="element-21733">
                <CheckCircleIcon className="h-6 w-6 text-green-400" data-id="element-21734" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-21735">
                <dl data-id="element-21736">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-21737">
                    Active Vendors
                  </dt>
                  <dd data-id="element-21738">
                    <div className="text-lg font-medium text-gray-900" data-id="element-21739">
                      {activeVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => handleViewVendorsByStatus('Pending Onboarding')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-21740">
          <div className="p-5" data-id="element-21741">
            <div className="flex items-center" data-id="element-21742">
              <div className="flex-shrink-0" data-id="element-21743">
                <ClockIcon className="h-6 w-6 text-blue-400" data-id="element-21744" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-21745">
                <dl data-id="element-21746">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-21747">
                    Pending Onboarding
                  </dt>
                  <dd data-id="element-21748">
                    <div className="text-lg font-medium text-gray-900" data-id="element-21749">
                      {pendingOnboarding}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => setCurrentView('vendors')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-21750">
          <div className="p-5" data-id="element-21751">
            <div className="flex items-center" data-id="element-21752">
              <div className="flex-shrink-0" data-id="element-21753">
                <AlertTriangleIcon className="h-6 w-6 text-yellow-400" data-id="element-21754" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-21755">
                <dl data-id="element-21756">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-21757">
                    Compliance Issues
                  </dt>
                  <dd data-id="element-21758">
                    <div className="text-lg font-medium text-gray-900" data-id="element-21759">
                      {complianceIssues}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>
      </div>

      {/* Recent Vendors and Compliance Issues */}
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-21760">
        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-21761">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-21762">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-21763">
              Recently Updated Vendors
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-21764">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-21765">
            {recentVendors.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-21766">
                No vendors found.
              </li> : recentVendors.map(vendor => <li key={vendor.vendorId} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendors')} data-id="element-21767">
                  <div className="flex items-center justify-between" data-id="element-21768">
                    <div className="flex items-center" data-id="element-21769">
                      <div className="flex-shrink-0" data-id="element-21770">
                        <UsersIcon className="h-5 w-5 text-gray-400" data-id="element-21771" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-21772">
                        {vendor.vendorName}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-21773">
                      {getStatusBadge(vendor.vendorStatus?.name)}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-21774">
                    <div className="sm:flex" data-id="element-21775">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-21776">
                        {vendor.type} • {vendor.country}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-21777">
                      <p data-id="element-21778">
                        Last updated:{' '}
                        <span className="ml-1.5" data-id="element-21779">
                          {new Date(vendor.createdUtc).toLocaleDateString(locale)}
                        </span>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>

        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-21780">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-21781">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-21782">
              Compliance Issues
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-21783">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-21784">
            {vendorsWithIssues.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-21785">
                No compliance issues found.
              </li> : vendorsWithIssues.map(vendor => <li key={vendor.vendorId} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendors')} data-id="element-21786">
                  <div className="flex items-center justify-between" data-id="element-21787">
                    <div className="flex items-center" data-id="element-21788">
                      <div className="flex-shrink-0" data-id="element-21789">
                        <AlertTriangleIcon className="h-5 w-5 text-yellow-400" data-id="element-21790" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-21791">
                        {vendor.vendorName}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-21792">
                      {vendor.isCompliant ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-21793">
                          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-21794" />
                          Compliant
                        </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-21795">
                          <AlertTriangleIcon className="mr-1 h-3 w-3" data-id="element-21796" />
                          Non-Compliant
                        </span>}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-21797">
                    <div className="sm:flex" data-id="element-21798">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-21799">
                        {getComplianceIssue(vendor)}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-21800">
                      <p data-id="element-21801">
                        <button className="text-indigo-600 hover:text-indigo-900" onClick={e => {
                    e.stopPropagation();
                    setCurrentView('vendors');
                  }} data-id="element-21802">
                          Review
                        </button>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>
      </div>
    </div>;
}
// Helper function to render status badges
function getStatusBadge(status) {
  switch (status) {
    case 'Active':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-21803">
          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-21804" />
          {status}
        </span>;
    case 'Pending Onboarding':
    case 'Invited':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-21805">
          <ClockIcon className="mr-1 h-3 w-3" data-id="element-21806" />
          {status}
        </span>;
    case 'Inactive':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-21807">
          <UsersIcon className="mr-1 h-3 w-3" data-id="element-21808" />
          {status}
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-21809">
          {status}
        </span>;
  }
}
function getComplianceIssue(vendor) {
  if (vendor.complianceIssues.length === 0) {
    return 'No specific issues';
  }
  const issue = vendor.complianceIssues[0];
  return issue.notes || issue.complianceIssueType.name;
}